<template>
	<v-card class="pa-4 mb-2" rounded>
		<v-card-title>
			<v-btn icon color="primary">
				<v-icon @click="refreshCurrentPage">
					refresh
				</v-icon>
			</v-btn>
			Resumen de Ventas
			<v-spacer/>
		</v-card-title>
		<v-card class="mb-4" flat outlined>
			<v-card-text>
				<v-daterange 
					v-model="dateRange"
					:value="dateRange"
					locale="es"
					color="orange"
					flat
					small
					filled
					dense
					light
					offset-y
					full-width
					:presets="dateRangePresets"
					:inputProps="{
						'block': true,
						'color': 'siiNaranjo',
						'dark': true,
						'label':'Fechas',
					}"
					:menuProps="{}"
					separatorLabel="↷"
				/>
<!-- 				<v-select
					v-model="reporte.filtros.estado"
					:items="estados"
					label="Filtrar por Estado"
					solo flat multiple dark
					color="blue"
				/> -->
<!-- 				<v-select
					v-model="reporte.filtros.medioPago"
					:items="medioPago"
					label="Filtrar por Medio de Pago"
					solo flat multiple dark
				/> -->
<!-- 				<v-select
					v-model="reporte.filtros.sucursal"
					:items="sucursal"
					label="Filtrar por Sucursal"
					solo flat multiple dark
				/> -->
			</v-card-text>
			<v-card-actions>
<!-- 				<v-btn @click="clearFiltros" color="error" outlined>
					<v-icon :left="$vuetify.breakpoint.lgAndUp">clear</v-icon>
					{{ $vuetify.breakpoint.lgAndUp ? 'Quitar Filtros':''}}
				</v-btn>
				<v-spacer/>
				<v-btn @click="loadPage()" color="primary">
					<v-icon left>filter_list</v-icon>Aplicar Filtros
				</v-btn> -->
			</v-card-actions>
		</v-card>
		<v-card>
		
		<v-card elevation="8" class="pa-4 mb-2">
			<v-list-item>
				<v-list-item-content>
					<v-list-item-subtitle>Monto Total</v-list-item-subtitle>
					<v-list-item-title>
						{{ reporte.totales.monto | moneyFilter }}
					</v-list-item-title>
				</v-list-item-content>
				<v-divider vertical class="mx-3"></v-divider>
				<v-list-item-content>
					<v-list-item-subtitle>Cantidad Emitida</v-list-item-subtitle>
					<v-list-item-title>
						{{reporte.totales.cantidad | milesFilter}}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
<!-- 			<v-card-text>
				total
				{{reporte.totales.monto}}
			</v-card-text> -->
		</v-card>

		</v-card>
		<v-card>
			<v-card-title>
				<v-spacer/>
				<descargar-reporte
						:key="`descargar-reporte_${viewConfig.descargaKey}`"
						:filtros="reporte.filtros"
						:dateRange="dateRange"
						:pagination="reporte.options"
						:headers="headers"
						@csv-exported="viewConfig.descargaKey++"
					/>
			</v-card-title>			
			<v-data-table
				:headers="headers"
				:items="reporte.lista"
				:options.sync="reporte.options"
				:server-items-length="reporte.totalRecords"

				:loading="reporte.isloading"
				:footer-props="reporte.footer"
				no-data-text="No hemos encontrado datos..."
				sort-by="fecha"
				sort-desc

			>
				<template v-slot:item.neto="{value}">
					{{ value | moneyFilter }}
				</template>
				<template v-slot:item.iva="{value}">
					{{ value | moneyFilter }}
				</template>
				<template v-slot:item.total="{value}">
					{{ value | moneyFilter }}
				</template>
				<template v-slot:item.exento="{value}">
					{{ value | moneyFilter }}
				</template>
				<template v-slot:item.dte="{value}">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<span v-on="on">{{diccionarioDte[value]}}</span>
						</template>
						<span>{{dtes[value]}}</span>
					</v-tooltip>
				</template>
				<template v-slot:item.anulado="{value}">
					<v-chip
			      class=""
			      :color="!value? 'primary':'error'"
			      text-color="white"
			    >
			      <v-avatar left>
			        <v-icon>{{!value? 'done': 'close'}}</v-icon>
			      </v-avatar>
			      {{!value? 'Emitida':'Anulada'}}
			    </v-chip>
				</template>
				<template v-slot:item.sucursal="{item, value}">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<span v-on="on">{{ (typeof value == 'string')? (value.length <= 11? value: value.slice(0, 10)+'...'): '-' }}</span>
						</template>
						<span>{{value}}</span>
					</v-tooltip>
					
				</template>
				<template v-slot:item.fecha="{item, value}">
					{{ /*(new Date(value)).toLocaleDateString()*/ getDateString(value) }}
				</template>
				<template v-slot:item.actions="{item}">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
			        <v-btn
								icon
								outlined
								color="primary"
								v-on="on"
								@click="showPDF(item)"
							>
								<v-icon>receipt</v-icon>
							</v-btn>
			      </template>
						<span>Ver PDF</span>
   				</v-tooltip>
				</template>
			</v-data-table>
		</v-card>
		<dte-emitido-vista
			:display="reporte.seleccionado.display"
			:url="reporte.seleccionado.url"
			:folio="reporte.seleccionado.folio"
			@close="reporte.seleccionado.display = false"
		/>
	</v-card>
</template>

<script>

import { API } from 'aws-amplify';
import { mapState } from 'vuex';

import * as dateFns from 'date-fns';
import moment from 'moment';

import VDaterange from '@/components/VDaterange';
import DescargarReporte from '@/views/Reporte/DescargarReporte';

import DteEmitidoVista from '@/views/Reporte/DteEmitidoVista';

import {tiposDte, diccionarioDte} from '@/vessi.utils.js';

export default {
	name: 'Reporte',
	components:{
		VDaterange,
		DteEmitidoVista,
		DescargarReporte
	},
	computed: {
		headers () {
			return [
				{
					text: 'Nro Folio',
					value: 'folio',
				},
				{
					text: 'Boleta',
					value: 'dte',
				},
				{
					text: 'Neto',
					value: 'neto',
				},
				{
					text: 'IVA',
					value: 'iva',
				},
				{
					text: 'Total',
					value: 'total',
				},
				// {
				// 	text: 'Exento',
				// 	value: 'exento',
				// },
				{
					text: 'Tipo',
					value: 'dte',
				},
				{
					text: 'Vendedor',
					value: 'vendedor',
				},
				{
					text: 'Sucursal',
					value: 'sucursal',
				},
				// {
				// 	text: 'Estado',
				// 	value: 'anulado',
				// },
				{
					text: 'Fecha',
					value: 'fecha',
				},
				{
					text: 'Acciones',
					value: 'actions',
					sortable: false
				}
			];
		},
		dateRangePresets: function(){
			let vm = this;
			return [
				{
					label: 'Ayer',
					range: [
						dateFns.format(dateFns.subDays(new Date(), 1), 'yyyy-MM-dd'),
						dateFns.format(dateFns.subDays(new Date(), 1), 'yyyy-MM-dd')
					]
				},
				{
					label: 'Última Semana',
					range: [
						dateFns.format(dateFns.subDays(new Date(), 7), 'yyyy-MM-dd'),
						dateFns.format(dateFns.subDays(new Date(), 0), 'yyyy-MM-dd')
					]
				},
				{
					label: 'Este Mes',
					range: [
						new Date().GetCurrentMonthRange().from,
						dateFns.format(dateFns.subDays(new Date(), 0), 'yyyy-MM-dd')
					]
				},
				{
					label: '6 Meses',
					range: [
						new Date().GetLast6Month().from,
						dateFns.format(dateFns.subDays(new Date(), 1), 'yyyy-MM-dd')
					]
				},
				{
					label: 'Último Año',
					range: [
						new Date().GetLastYear().from,
						dateFns.format(dateFns.subDays(new Date(), 0), 'yyyy-MM-dd')
					]
				}
			]
		},
		dtes(){
			return tiposDte;
		},
		diccionarioDte(){
			return diccionarioDte;
		},
		...mapState('empresas',['selected']),
	},
	data () {
		return {
			estados:[
				'Emitida',
				'Anulada'
			],
			medioPago:[
				'Débito',
				'Crédito',
				'Efectivo',
				'Otro'
			],
			sucursal:[
				'Bernarda Morin 510, Providencia, Región Metropolitana, Chile',
				'Pasaje Patrón Armando Barrera Silva 4433, Cochabamba, Región Metropolitana, Chile',
				'Doctor Manuel Barros Borgoño 420, Providencia, Región Metropolitana, Chile'
			],
			reporte:{
				totales:{
					cantidad: '-',
					monto: 0
				},
				isloading: false,
				lista:[],
				filtros:{
					estado:[],
					sucursal:[],
					medioPago:[],
					tipo_dte:[]
				},
				options:{
					page: 1,
					sortBy: [],
					sortDesc: [],
					itemsPerPage: 10
				},
				totalRecords:0,
				apiCall: null,
				seleccionado:{
					display: false,
					folio: undefined,
					tipoDte: undefined
				},
				footer: {
					'items-per-page-options': [5, 10, 15, 20, 30, 50, 100, 250]
				},
			},
			viewConfig:{
				descargaKey:0
			},
			dateRange:{
				from: new Date().yyyymmdd(),
				to: new Date().yyyymmdd()
			},
		}
	},
	methods:{
		getReportes: async function(pag=0){


			let resp = null;
			let vm = this;

			if( !vm.$store.getters['empresas/seleccionada'] ) return;

			vm.reporte.lista = [];
			vm.reporte.isloading = true;

			let filtros = [];

			let getFilter = function( name, value ){
				return {name: name, value: value};
			}

			// filtros.push( getFilter('tipo_dte', [39]) );

			if( vm.reporte.filtros.estado.length > 0 ) filtros.push(getFilter('estados', vm.reporte.filtros.estado));
			if( vm.reporte.filtros.tipo_dte.length > 0 ) filtros.push(getFilter('tipo_dte', vm.reporte.filtros.tipo_dte));
			if( vm.reporte.filtros.medioPago.length > 0 ) filtros.push(getFilter('medioPago', vm.reporte.filtros.medioPago));
			if( vm.reporte.filtros.sucursal.length > 0 ) filtros.push(getFilter('sucursal', vm.reporte.filtros.sucursal));

			// let pagination = JSON.parse( JSON.stringify(vm.reporte.options) );

			let params = {
				queryStringParameters: {
					contribuyente: vm.$store.getters['empresas/seleccionada'].rut,
					filtros: JSON.stringify(filtros),
					pagination: JSON.stringify(vm.reporte.options),
					dateRange: JSON.stringify(vm.dateRange)
				},
				headers: {}
			};

			try{

				if( vm.reporte.apiCall != null )
					API.cancel(vm.reporte.apiCall, "Se ha vuelto a llamar");

				vm.reporte.apiCall = API.get('apiBoletaSII', '/consultar-reportes', params);

				resp = await vm.reporte.apiCall;

				vm.reporte.lista = resp.reporte;
				vm.reporte.isloading = false;

				vm.reporte.totalRecords = vm.reporte.lista.length > 0 ? parseInt(vm.reporte.lista[0].cantidad_total):0;

				vm.reporte.totales.monto = resp.resumen.total;
				vm.reporte.totales.cantidad = resp.resumen.cantidad_emitida;
			}catch(err){
				// console.log(err);
			}finally {
				vm.reporte.apiCall = null;
			}
		},
		clearFiltros: function(){
			this.reporte.filtros.estado = [];
			this.reporte.filtros.sucursal = [];
			this.reporte.filtros.medioPago = [];

			this.loadPage(1);
		},
		loadPage: function(page=1){
			let vm = this;
			vm.reporte.options.page = page;
			vm.getReportes(page);
		},
		refreshCurrentPage: function(){
			this.loadPage( this.reporte.options.page );
		},
		showPDF: function(item){
			
			this.reporte.seleccionado.display=true;
			this.reporte.seleccionado.url=item.pdf;
			this.reporte.seleccionado.folio=item.folio;
		},
		getDateString: function(date){
			let timezoneLess = moment.utc(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
			return timezoneLess;
		}
	},
	mounted(){
		
		this.getReportes();
	},
	watch:{
		dateRange(){
			this.loadPage();
		},
		'reporte.options': {
			deep: true,
			handler() {
				
				this.getReportes();
			}
		},
		selected(){
			this.loadPage();
		}
	}
}
</script>

<style lang="css" scoped>
</style>